import { labDaysBefore } from '@/domain';
import type { ReportRange } from '@/application/ports/ReportRepository';
import { labToday } from '@/shared/format/instant';

/** How many lab days each reporting range covers, today included. */
const PERIOD_DAYS: Record<Exclude<ReportRange, 'all'>, number> = { today: 1, week: 7, month: 30 };

/** The ranges as every picker offers them: All time first, the default since the lab's request of 17 October 2026. */
export const REPORT_RANGES: readonly ReportRange[] = ['all', 'today', 'week', 'month'];

/**
 * The archive narrowed to the days a period covers, as the report counts them:
 * where a figure of the cases that left in the period opens. All time is the
 * whole archive. The lab's request of 17 October 2026, item 1.
 */
export function archiveOfPeriod(range: ReportRange): string {
  if (range === 'all') return '/archive';
  const today = labToday();
  return `/archive?from=${labDaysBefore(today, PERIOD_DAYS[range] - 1)}&to=${today}`;
}
